import * as React from 'react';
var isTestEnv = process.env.NODE_ENV === 'test';
export function getParentNode(element) {
    if (element.nodeName === 'HTML') {
        return element;
    }
    // @ts-ignore
    return element.parentNode || element.host;
}
function getStyleComputedProperty(element) {
    // NOTE: 1 DOM access here
    var window = element.ownerDocument.defaultView;
    // @ts-ignore
    return window.getComputedStyle(element, null);
}
// @ts-ignore
export function getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) {
        return document.body;
    }
    switch (element.nodeName) {
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            // @ts-ignore
            return element.body;
        default:
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _a = getStyleComputedProperty(element), overflow = _a.overflow, overflowX = _a.overflowX, overflowY = _a.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
        return element;
    }
    return getScrollParent(getParentNode(element));
}
export var buildChildrenObject = function (children, childrenObject) {
    return React.Children.toArray(children).reduce(function (acc, child) {
        if (!React.isValidElement(child)) {
            return acc;
        }
        if (!child.type || !child.type.displayName) {
            return acc;
        }
        var name = child.type.displayName.split('.').pop();
        // @ts-ignore
        acc[name] = child;
        return acc;
    }, childrenObject || {});
};
export var createComponentThatRendersItsChildren = function (displayName) {
    var Element = function (_a) {
        var children = _a.children;
        return typeof children === 'string'
            ? React.createElement('div', {}, children)
            : children;
    };
    Element.displayName = displayName;
    return Element;
};
export var noop = function () { return null; };
export var isReactElement = function (child, Element) {
    return child && child.type === Element;
};
export var isStatelessComponent = function (Component) {
    return !(Component.prototype && Component.prototype.render);
};
export var attachClasses = function (node, classnames) {
    var _a;
    return node && (_a = node.classList).add.apply(_a, classnames.split(' '));
};
export var detachClasses = function (node, classnames) {
    var _a;
    return node && (_a = node.classList).remove.apply(_a, classnames.split(' '));
};
export var shouldAnimatePopover = function (_a) {
    var timeout = _a.timeout;
    if (typeof timeout === 'object') {
        var enter = timeout.enter, exit = timeout.exit;
        return (typeof enter !== 'undefined' &&
            typeof exit !== 'undefined' &&
            (enter > 0 || exit > 0));
    }
    return !!timeout;
};
export var getArrowShift = function (shift, direction) {
    if (!shift && !isTestEnv) {
        return {};
    }
    if (direction.startsWith('top') || direction.startsWith('bottom')) {
        return { left: "".concat(shift, "px") };
    }
    if (direction.startsWith('left') || direction.startsWith('right')) {
        return { top: "".concat(shift, "px") };
    }
    // Arrow can't be shifted when using automatic positioning
    return {};
};
//# sourceMappingURL=utils.js.map